import { AppPermissions } from "constants/permissions"
import NewAddNotificationTemplate from "pages/notification-new/add-template"
import CreateNotificationTrigger from "pages/notification-new/create-trigger"
import NewNotificationTriggers from "pages/notification-new/notification-triggers"
import NewNotificationTemplates from "pages/notification-new/templates"
import DCRegistration from "pages/registration/dc/DCRegistration"
import DockRegistration from "pages/registration/dc/docks/DockRegistration"
import Docks from "pages/registration/dc/docks/Docks"
import React from "react"
import { VesaRouteType } from "routes"
import Companies from "../pages/registration/company/Companies"
import CompanyRegisteration from "../pages/registration/company/CompanyRegisteration"
import ContractRegistration from "../pages/registration/contract/ContractRegistration"
import CropRegistrationForm from "../pages/registration/crop/CropRegistrationForm"
import DistributionCenters from "../pages/registration/dc/DistributionCenters"
import DepartmentRegistration from "../pages/registration/department/DepartmentRegistration"
import Departments from "../pages/registration/department/Departments"
import FarmerRegistration from "../pages/registration/farmer/FarmerRegistration"
// Farmer Registration
import Farmers from "../pages/registration/farmer/Farmers"
import Groups from "../pages/registration/group/Groups"
import Crops from "../pages/registration/plot/Crops"
import PlotRegistration from "../pages/registration/plot/PlotRegistration"
import SellableItemRegistration from "../pages/registration/sellableitem/SellableItemRegistration"
import SellableItems from "../pages/registration/sellableitem/SellableItems"
import SkuRegistration from "../pages/registration/sku/SkuRegistration"
// Sku Registration
import Skus from "../pages/registration/sku/Skus"
import UserRegistration from "../pages/registration/user/UserRegistration"
import Users from "../pages/registration/user/Users"
import VehicleDriverRegistration from "../pages/registration/vehicle/VehicleDriverRegistration"
import VehicleOwnerRegistration from "../pages/registration/vehicle/VehicleOwnerRegistration"
import VehicleRegistration from "../pages/registration/vehicle/VehicleRegistration"
import Vehicles from "../pages/registration/vehicle/Vehicles"
import VendorMap from "../pages/registration/vendor/VendorMap"
import VendorRegistration from "../pages/registration/vendor/VendorRegistration"
import Vendors from "../pages/registration/vendor/Vendors"
const REGISTERATION_ROUTES: VesaRouteType[] = [
  {
    icon: "user",
    title: "User",
    path: "user",
    type: "Admin",
    permission: ["ds_view_user"],
    element: <Users />,
  },
  {
    path: "user/:id",
    permission: ["ds_view_user"],
    element: <UserRegistration />,
    hide: true,
  },
  {
    icon: "people",
    title: "Groups",
    path: "group",
    type: "Admin",
    element: <Groups />,
  },
  {
    icon: "briefcase",
    title: "Department",
    path: "department",
    type: "Admin",
    permission: ["ds_view_department"],
    element: <Departments />,
  },
  {
    path: "department/:id",
    permission: ["ds_view_department"],
    element: <DepartmentRegistration />,
    hide: true,
  },
  {
    icon: "office",
    title: "Companies",
    path: "company",
    type: "Admin",
    permission: ["ds_view_company"],
    element: <Companies />,
  },
  {
    path: "company/:id",
    permission: ["ds_view_company"],
    element: <CompanyRegisteration />,
    hide: true,
  },
  {
    icon: "box",
    title: "SKU",
    path: "sku",
    type: "Farm Operations",
    permission: ["ds_view_sku"],
    element: <Skus />,
  },
  {
    path: "sku/:id",
    permission: ["ds_view_sku"],
    element: <SkuRegistration />,
    hide: true,
  },
  {
    icon: "tree",
    title: "Crop",
    path: "crop",
    type: "Farm Operations",
    permission: ["ds_view_crop"],
    element: <Crops />,
  },
  {
    path: "crop/:id",
    permission: ["ds_view_crop"],
    element: <CropRegistrationForm />,
    hide: true,
  },
  {
    icon: "known-vehicle",
    title: "Vehicle",
    path: "vehicle",
    type: "Farm Operations",
    permission: ["ds_view_vehicle"],
    element: <Vehicles />,
  },
  {
    path: "vehicle/:id",
    permission: ["ds_view_vehicle"],
    element: <VehicleRegistration />,
    hide: true,
  },
  {
    icon: "shop",
    title: "Supplier",
    path: "supplier",
    type: "Farm Operations",
    permission: ["ds_view_supplier"],
    element: <Farmers />,
  },
  {
    path: "supplier/:id",
    permission: ["ds_view_supplier"],
    element: <FarmerRegistration />,
    hide: true,
  },
  {
    icon: "polygon-filter",
    title: "Plot",
    path: "plot/:id",
    permission: ["ds_view_supplier"],
    element: <PlotRegistration />,
    hide: true,
  },
  {
    path: "owner/:id",
    permission: [
      "vt_view_inward",
      "vt_view_supplier_management",
      "vt_view_schedule",
    ],
    element: <VehicleOwnerRegistration />,
    hide: true,
  },
  {
    path: "driver/:id",
    permission: [
      "vt_view_inward",
      "vt_view_supplier_management",
      "vt_view_schedule",
    ],
    element: <VehicleDriverRegistration />,
    hide: true,
  },
  {
    path: "contract/:id",
    element: <ContractRegistration />,
    hide: true,
  },
  {
    path: "dc",
    type: "E-Commerce",
    icon: "office",
    title: "Distribution Centers",
    permission: ["ds_view_dc"],
    element: <DistributionCenters />,
  },
  {
    path: "dc/:id/*",
    element: <DCRegistration />,
    permission: ["ds_view_dc"],
    hide: true,
  },
  {
    path: "sellable-items/:id",
    element: <SellableItemRegistration />,
    permission: ["ds_view_sellable_item"],
    hide: true,
  },
  {
    path: "sellable-items",
    type: "E-Commerce",
    icon: "shopping-cart",
    title: "Sellable Items",
    permission: ["ds_view_sellable_item"],
    element: <SellableItems />,
  },
  {
    path: "vendors",
    type: "E-Commerce",
    icon: "user",
    title: "Vendor",
    permission: ["ds_view_vendor"],
    element: <Vendors />,
  },
  {
    path: "dock",
    type: "E-Commerce",
    icon: "truck",
    title: "Dock",
    permission: [AppPermissions.canViewDock],
    element: <Docks />,
  },
  {
    path: "dock/:id",
    permission: [AppPermissions.canViewDock],
    element: <DockRegistration />,
    hide: true,
  },
  {
    path: "vendors/details/:id",
    element: <VendorRegistration />,
    permission: ["ds_view_vendor"],
    hide: true,
  },

  {
    path: "vendors/map",
    element: <VendorMap />,
    permission: ["ds_view_vendor"],
  },
  {
    path: "notification-templates",
    type: "Notification",
    icon: "notifications",
    title: "Notification Templates",
    permission: ["ds_view_notification_template"],
    element: <NewNotificationTemplates />,
  },
  {
    path: "notification-templates/:id",
    type: "Notification",
    element: <NewAddNotificationTemplate />,
    permission: ["ds_view_notification_template"],
    hide: true,
  },
  {
    path: "notifications",
    icon: "notifications-updated",
    title: "Notifications",
    type: "Notification",
    permission: ["ds_view_notification"],
    element: <NewNotificationTriggers />,
  },
  {
    path: "notifications/:id",
    type: "Notification",
    element: <CreateNotificationTrigger />,
    permission: ["ds_view_notification"],
    hide: true,
  },
]

export default REGISTERATION_ROUTES
